import { CasinoFilterTypeEnum, ILayoutsCasinoSectionsFilterConfig } from "@finbackoffice/fe-core";
import { useLayoutCasinoConfig } from "@finbackoffice/site-core";
import { useCasinoScope } from "hooks";
import { FC, useCallback, useMemo } from "react";
import SidebarCasinoFilter from "components/side-bar/common/casino-filter/SidebarCasinoFilter";

type IProps = {
    filterClassname?: string;
};

const SidebarCasinoFiltersContainer: FC<IProps> = ({ filterClassname }) => {
    const { casinoFiltersConfig: casinoSlotsFiltersConfig } = useLayoutCasinoConfig("slots");
    const { casinoFiltersConfig: casinoLiveCasinoFiltersConfig } =
        useLayoutCasinoConfig("livecasino");
    const { scope } = useCasinoScope();

    const renderSidebarCasinoFilter = useCallback(
        (filter: ILayoutsCasinoSectionsFilterConfig) => (
            <SidebarCasinoFilter filter={filter} classname={filterClassname} key={filter.value} />
        ),
        [filterClassname],
    );

    const liveCasinoFiltersMemo = useMemo(
        () => <>{casinoLiveCasinoFiltersConfig.map(renderSidebarCasinoFilter)}</>,
        [casinoLiveCasinoFiltersConfig, renderSidebarCasinoFilter],
    );

    const slotsFiltersMemo = useMemo(() => {
        const tagFilters = casinoSlotsFiltersConfig.filter(
            (filter) => filter.type === CasinoFilterTypeEnum.Tag,
        );
        const propFilters = casinoSlotsFiltersConfig.filter(
            (filter) => filter.type === CasinoFilterTypeEnum.Prop,
        );

        return (
            <>
                {tagFilters.map(renderSidebarCasinoFilter)}
                {propFilters.map(renderSidebarCasinoFilter)}
            </>
        );
    }, [casinoSlotsFiltersConfig, renderSidebarCasinoFilter]);

    const filtersMemo = useMemo(() => {
        switch (scope) {
            case "slots":
                return slotsFiltersMemo;
            case "livecasino":
                return liveCasinoFiltersMemo;
            default:
                return slotsFiltersMemo;
        }
    }, [liveCasinoFiltersMemo, scope, slotsFiltersMemo]);

    if (!filtersMemo) {
        return null;
    }

    return filtersMemo;
};

export default SidebarCasinoFiltersContainer;
